import AppModule from "@/services/App/AppModule.js";
import AppModuleType from "@/services/App/AppModuleType.js";

export default {
  // required in model
  Module: AppModule.Stock,
  ModuleType: {
    Export: AppModuleType.Export
  }
}